import * as amplitude from '@amplitude/analytics-browser';
import { SnakecaseSerializer } from 'cerealizr';

const snakeSerializer = new SnakecaseSerializer();

const trackEvent = (name, properties) => {
  amplitude.track(name, snakeSerializer.serialize(properties));
};

export default {
  trackEvent
};
